(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.body.classList.add('rd-delay-klaviyo-popup');

window.setTimeout(function () {
  document.body.classList.remove('rd-delay-klaviyo-popup');
}, 20000);

  } catch(e) { console.error(e); }
})();
})();
